import { render, staticRenderFns } from "./AreaExpansionChartController.vue?vue&type=template&id=47f5b3b1&scoped=true&"
import script from "./AreaExpansionChartController.vue?vue&type=script&lang=ts&"
export * from "./AreaExpansionChartController.vue?vue&type=script&lang=ts&"
import style0 from "./area-expansion-chart-controller.scss?vue&type=style&index=0&id=47f5b3b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5b3b1",
  null
  
)

export default component.exports